module.exports = __webpack_public_path__ + "static/img/home_example.13ec6222.png";